import { NAME_SPACE } from './constants'
import { 
    getExpenseNatureListApi, 
    addAndUpdateNatureApi, 
    setExpenseNatureStatusApi, 
    getCustomerFunctionListApi, 
    setAddAndUpdateCustomerFunctionSaveApi, 
    setcustomerFunctionStatusApi,
    getItemTypeListApi,
    addItemTypeApi,
    setItemTypeStatusApi,
    getAccountTitleAllApi,
    addAccountTitleSaveApi,
    changeAccountTitleStatusApi,
    getAnalysisTitleAllApi,
    addAnalysisTitleSaveApi,
    changeAnalysisTitleStatusApi,
    getFundUseageListApi,
    setFundUsageSaveApi,
    changeFundUsageStatusApi
} from './service'
const initData = () => ({
    natureList:[],
    qualificationList: [],
    customerFunctionList:[],
    itemTypeList:[],
    accountTitleAllList: [],
    analysisTitleAllList: [],
    fundUsageList: [],
    pageInfor:{
      cur_page: 1,
      per_page: 10,
      total_count: 0,
    },
    loading:{
        getExpenseNatureListLoading:false,
        addAndUpdateNatureLoading:false,
        setExpenseNatureStatusLoading:false,
        getCustomerFunctionListLoading:false,
        setAddAndUpdateCustomerFunctionSaveLoading:false,
        setcustomerFunctionStatusLoading:false,
        getItemTypeListLoading:false,
        addItemTypeLoading:false,
        setItemTypeStatusLoading:false,
        getAccountTitleAllLoading:false,
        addAccountTitleSaveLoading:false,
        changeAccountTitleStatusLoading:false,
        getAnalysisTitleAllLoading:false,
        addAnalysisTitleSaveLoading:false,
        changeAnalysisTitleStatusLoading:false,
        getFundUseageListLoading:false,
        setFundUsageSaveLoading:false,
        changeFundUsageStatusLoading:false,
    },
})
const model = {
    name: NAME_SPACE,
    namespaced: true,
    state: initData(),
    mutations: {
      setStateLevel0(state, {key, value}) {
        state[key] = value
      },
      setLoading(state, {key, value}) {
        state.loading[key] = value
      },
      initData(state) {
        const new_state = initData()
        Object.keys(state).forEach(key => {
          state[key] = new_state[key]
        })
      },
    },
    actions: {
        // 获取费用nature
        async getExpenseNatureList({ commit }, params = {}) {
           const pageParams = {
            page: params.cur_page || 1,
            per_page: params.per_page || 10,
           }
           if (params.search) { // 费用 nature 模块搜索
            pageParams.search = params.search
           }
           commit('setLoading', { key:'getExpenseNatureListLoading', value:true })
           const result = await getExpenseNatureListApi({
              ...pageParams,
              final() {
                commit('setLoading', { key:'getExpenseNatureListLoading', value:false })
              }
           })
           commit('setStateLevel0', { key:'pageInfor', value: {
              cur_page: result.cur_page,
              per_page: result.per_page,
              total_count: result.total_count,
            }
           })
           commit('setStateLevel0', { key:'natureList', value:(result && result.natures) || [] })
        },
          // 增加修改费用nature
        async addAndUpdateNature({commit, dispatch, state:{ pageInfor } }, params) {
            const {success, ...other} = params
            commit('setLoading', { key:'addAndUpdateNatureLoading', value:true })
            await addAndUpdateNatureApi({
                ...other,
                final() {
                  commit('setLoading', { key:'addAndUpdateNatureLoading', value:false })
                }
             })
             success()
             dispatch({type:'getExpenseNatureList', ...pageInfor, cur_page:1})
        },
         // 修改费用nature的状态
        async setExpenseNatureStatus({ commit, dispatch, state:{ pageInfor } }, params) {
            const {success, ...other} = params
            commit('setLoading', { key:'setExpenseNatureStatusLoading', value:true })
            await setExpenseNatureStatusApi({
                ...other,
                final() {
                  commit('setLoading', { key:'setExpenseNatureStatusLoading', value:false })
                }
             })
             success()
             dispatch({type:'getExpenseNatureList', ...pageInfor})
        },
        // 获取职能列表
        async getCustomerFunctionList({ commit }) {
            commit('setLoading', { key:'getCustomerFunctionListLoading', value:true })
            const result = await getCustomerFunctionListApi({
               final() {
                 commit('setLoading', { key:'getCustomerFunctionListLoading', value:false })
               }
            })
            commit('setStateLevel0', { key:'customerFunctionList', value:(result && result.customer_functions) || [] })
        },
        // 新增或者编辑职能
        async setAddAndUpdateCustomerFunctionSave({commit, dispatch}, params) {
            const {success, ...other} = params
            commit('setLoading', { key:'setAddAndUpdateCustomerFunctionSaveLoading', value:true })
            await setAddAndUpdateCustomerFunctionSaveApi({
                ...other,
                final() {
                  commit('setLoading', { key:'setAddAndUpdateCustomerFunctionSaveLoading', value:false })
                }
             })
             success()
             dispatch({type:'getCustomerFunctionList', value:{}})
            // dispatch({ type:'getCustomerFunctionList' })
        },
        // setcustomerFunctionStatusApi
        async setcustomerFunctionStatus({ commit, dispatch }, params) {
            const {success, ...other} = params
            commit('setLoading', { key:'setcustomerFunctionStatusLoading', value:true })
            await setcustomerFunctionStatusApi({
                ...other,
                final() {
                  commit('setLoading', { key:'setcustomerFunctionStatusLoading', value:false })
                }
             })
             success()
             dispatch({type:'getCustomerFunctionList'})
        },
        // 获取产品类型列表
        async getItemTypeList({ commit }) {
            commit('setLoading', { key:'getItemTypeListLoading', value:true })
            const result = await getItemTypeListApi({
               final() {
                 commit('setLoading', { key:'getItemTypeListLoading', value:false })
               }
            })
            commit('setStateLevel0', { key:'itemTypeList', value:(result && result.item_types) || [] })
        },
        // addItemTypeApi
        async addItemType({commit, dispatch}, params) {
            const {success, ...other} = params
            commit('setLoading', { key:'addItemTypeLoading', value:true })
            await addItemTypeApi({
                ...other,
                final() {
                  commit('setLoading', { key:'addItemTypeLoading', value:false })
                }
             })
             success()
             dispatch({type:'getItemTypeList'})
        },
        async setItemTypeStatus({commit, dispatch}, params) {
            const {success, ...other} = params
            commit('setLoading', { key:'setItemTypeStatusLoading', value:true })
            await setItemTypeStatusApi({
                ...other,
                final() {
                  commit('setLoading', { key:'setItemTypeStatusLoading', value:false })
                }
             })
             success()
             dispatch({type:'getItemTypeList'})
        },
        async getAccountTitleAll({ commit }) {
            commit('setLoading', { key:'getAccountTitleAllLoading', value:true })
            const result = await getAccountTitleAllApi({
               final() {
                 commit('setLoading', { key:'getAccountTitleAllLoading', value:false })
               }
            })
            const stack = [ ...result ]
            while (stack.length) {
                const current = stack[stack.length - 1]
                stack.pop()
                current.children = current.account_titles || []
                delete current.account_titles
                current.children.forEach((item) => {
                    stack.push(item)
                })
            }
            commit('setStateLevel0', { key:'accountTitleAllList', value:[
                {
                    id:0,
                    name:'会计科目',
                    children: result
                }
            ] || [] })
        },
        // 新增编辑会计科目
        async addAccountTitleSave({commit, dispatch}, params) {
            const {success, ...other} = params
            commit('setLoading', { key:'addAccountTitleSaveLoading', value:true })
            await addAccountTitleSaveApi({
                ...other,
                final() {
                  commit('setLoading', { key:'addAccountTitleSaveLoading', value:false })
                }
             })
             success()
             dispatch({type:'getAccountTitleAll'})
        },
        async changeAccountTitleStatus({commit, dispatch}, params) {
          const {success, ...other} = params
          commit('setLoading', { key:'changeAccountTitleStatusLoading', value:true })
          await changeAccountTitleStatusApi({
              ...other,
              final() {
                commit('setLoading', { key:'changeAccountTitleStatusLoading', value:false })
              }
           })
           success()
           dispatch({type:'getAccountTitleAll'})
      },
      // 分析科目
      async getAnalysisTitleAll({ commit }) {
        commit('setLoading', { key:'getAnalysisTitleAllLoading', value:true })
        const result = await getAnalysisTitleAllApi({
           final() {
             commit('setLoading', { key:'getAnalysisTitleAllLoading', value:false })
           }
        })
        const stack = [ ...result ]
        while (stack.length) {
            const current = stack[stack.length - 1]
            stack.pop()
            current.children = current.analysis_titles || []
            delete current.analysis_titles
            current.children.forEach((item) => {
                stack.push(item)
            })
        }
        commit('setStateLevel0', { key:'analysisTitleAllList', value:[
            {
                id:0,
                name:'分析科目',
                children: result
            }
        ] || [] })
      },
      async addAnalysisTitleSave({commit, dispatch}, params) {
        const {success, ...other} = params
        commit('setLoading', { key:'addAnalysisTitleSaveLoading', value:true })
        await addAnalysisTitleSaveApi({
            ...other,
            final() {
              commit('setLoading', { key:'addAnalysisTitleSaveLoading', value:false })
            }
         })
         success()
         dispatch({type:'getAnalysisTitleAll'})
      },
      async changeAnalysisTitleStatus({commit, dispatch}, params) {
        const {success, ...other} = params
        commit('setLoading', { key:'changeAnalysisTitleStatusLoading', value:true })
        await changeAnalysisTitleStatusApi({
            ...other,
            final() {
              commit('setLoading', { key:'changeAnalysisTitleStatusLoading', value:false })
            }
         })
         success()
         dispatch({type:'getAnalysisTitleAll'})
      },
      // 获取用途列表
      async getFundUseageList({ commit }) {
         commit('setLoading', { key:'getFundUseageListLoading', value:true })
         const result = await getFundUseageListApi({
            final() {
              commit('setLoading', { key:'getFundUseageListLoading', value:false })
            }
         })
         commit('setStateLevel0', { key:'fundUsageList', value:(result && result.usages) || [] })
      },
      // 新增编辑用途 setFundUsageSaveApi
      async setFundUsageSave({commit, dispatch}, params) {
        const {success, ...other} = params
        commit('setLoading', { key:'setFundUsageSaveLoading', value:true })
        await setFundUsageSaveApi({
            ...other,
            final() {
              commit('setLoading', { key:'setFundUsageSaveLoading', value:false })
            }
         })
         success()
         dispatch({type:'getFundUseageList', value:{}})
      },
      // 修改状态 changeFundUsageStatusApi
      async changeFundUsageStatus({ commit, dispatch }, params) {
        const {success, ...other} = params
        commit('setLoading', { key:'changeFundUsageStatusLoading', value:true })
        await changeFundUsageStatusApi({
            ...other,
            final() {
              commit('setLoading', { key:'changeFundUsageStatusLoading', value:false })
            }
         })
         success()
         dispatch({type:'getFundUseageList'})
      }
    }
  };
  
  export default model;
  